import { useKnockSlackClient as L } from "../context/KnockSlackProvider.mjs";
import { useMemo as N, useEffect as g } from "react";
import "../../i18n/context/KnockI18nProvider.mjs";
import A from "swr/infinite";
import { useKnockClient as I } from "../../core/context/KnockProvider.mjs";
import "@knocklabs/client";
import "zustand/shallow";
import "date-fns";
const P = 1e3, K = 200, M = "private_channel,public_channel", u = "SLACK_CHANNELS";
function z(n, e) {
  return n === 0 ? [u, ""] : e && ["", null].includes(e.next_cursor) ? null : [u, e.next_cursor ?? ""];
}
function V({
  queryOptions: n
}) {
  var C, _;
  const e = I(), {
    knockSlackChannelId: S,
    tenant: d,
    connectionStatus: a
  } = L(), x = (c) => e.slack.getChannels({
    tenant: d,
    knockChannelId: S,
    queryOptions: {
      ...n,
      cursor: c ? c[1] : "",
      limit: (n == null ? void 0 : n.limitPerPage) || K,
      types: (n == null ? void 0 : n.types) || M
    }
  }), {
    data: t,
    error: i,
    isLoading: l,
    isValidating: o,
    size: m,
    setSize: f,
    mutate: E
  } = A(z, x, {
    initialSize: 0
  }), r = (t == null ? void 0 : t.length) || 0, h = r === 0 || t && ((C = t[r]) == null ? void 0 : C.next_cursor) && ((_ = t[r]) == null ? void 0 : _.next_cursor) !== "", s = N(() => (t ?? []).flatMap((c) => c == null ? void 0 : c.slack_channels).filter((c) => !!c), [t]), k = (n == null ? void 0 : n.maxCount) || P;
  return g(() => {
    a === "connected" && !i && h && !l && !o && s.length < k && f(m + 1);
  }, [s.length, f, m, h, l, o, k, i, a]), {
    data: s,
    isLoading: l || o,
    refetch: () => E()
  };
}
export {
  V as default
};
//# sourceMappingURL=useSlackChannels.mjs.map
